import api from '../api';

export const getTalentPools = () => {
  return api.get('/company/v2/talent-pools', {
    // Explicitly set the role here
    role: 'company'
  });
};

export const getTalentPool = (talentPoolId) => {
  return api.get(`/company/v2/talent-pools/${talentPoolId}`, {
    role: 'company'
  })
} 

export const getWorkTypes = () => {
  return api.get('/company/v2/work-types')
}

export const createTalentPool = (data) => {
  return api.post('/company/v2/talent-pools', data , {
    role: 'company'
  });
};

export const getMembers = (talentPoolId) => {
  return api.get(`/company/v2/talent-pools/${talentPoolId}/members`, {
    role: 'company'
  });
};

export const getMemberResume = (talentPoolId, memberId) => {
  return api.get(`/company/v2/talent-pools/${talentPoolId}/members/${memberId}/resume`, {
    role: 'company',
    responseType: 'blob'
  })
}